<div [ngClass]="{'cnt-row': _xeroLinks }">
    <div [height]="20"></div>
    <div *ngFor="let item of _xeroLinks; let i = index; last as isLast;" [width]="item.width">

        <div *ngIf="showInfoPopup && showLabel" [ngClass]="{'labelFormRow': !item.width }">
            <infoPopUp [pFieldID]="'Xero_Link_Help'"
                       [logoText]="item.LinkHeading"
                       (infoOpened)="closeOtherInfoPanels($event)"
                       [dCreator]="getDialogCreator()"
                       >
            </infoPopUp>
        </div>

        <div *ngIf="!showInfoPopup && showLabel" class="{{linkHeadingCls}}" [ngClass]="{'labelFormRow': !item.width }">
            {{item.LinkHeading}}
        </div>

        <div *ngIf="showLabel" [height]="8"></div>

        <div [ngClass]="{'formRow': !item.width && parentName && parentName !== 'default', 'labelFormRow': !parentName || parentName === 'default' }">
            <combo style="display:inline-block" hint=""
                   [hasOutline]="true"
                   [backgroundColor]="'white'"
                   [ComboData]="_xeroLinkData[i]"
                   [ngModel]="item.XeroAccountCode"
                   (selectitem)="onXeroLinkChange($event, item.LinkField, item.XeroAccountHeading ?? '')"
                   [showImg]="false"
                   label=""
                   [height]="30"

                   [inputTextClass]="'small-field'"
                   [emptyDisplayValue]="'Unmatched'"
                   [usePrevValue]="false"
                   [width]="265"
                   [testId]="item.LinkHeading">
            </combo>
        </div>

        <ng-container *ngIf="parentName && parentName !== 'default'">
            <div [height]="25"></div>
            <div class="line g4Background"></div>
            <div *ngIf="!isLast" [height]="20"></div>
        </ng-container>

        <ng-container *ngIf="!parentName">
            <div *ngIf="!item.width" [height]="15"></div>
        </ng-container>

    </div>

</div>
